import {requestHelpers} from '../../helpers';

const actions = {
  GET_TAGS: 'GET_TAGS',
  SET_TAGS: 'SET_TAGS'
};

function getTags()  {

  return (dispatch) => {
    dispatch({
      type: actions.GET_TAGS,
    });

    requestHelpers.authenticatedGetRequest('/common/tags')
      .then((response) => {
        dispatch({
          type: actions.SET_TAGS,
          tags: response.data
        })
      })
  }
}

module.exports = {
  actions,
  getTags,
};



// WEBPACK FOOTER //
// src/client/actions/common/tags2.js